enum PurchaseOrderStateEnum {
    PRELIMINARY = 1,
    SUBMITTED,
    AWAITING_APPROVAL,
    ACCEPTED,
    IN_PROGRESS,
    CONFIRMED,
    REJECTED,
    SHIPPED,
    PARTIALLY_SHIPPED,
    RECEIVED,
    INCOMING,
}

export default PurchaseOrderStateEnum;
